import { map } from "@thi.ng/transducers";

import { IRect, IRoom } from "../../api";

export const roomComponent = (room: IRoom, rect: IRect) => {
  const { x, y, w, h } = rect;

  return [
    ["rect", { stroke: "rgb(255, 255, 255, 0.5)", weight: 1 }, [x, y], w, h],

    ...map((object) => {
      const scaledRect: IRect = {
        x: rect.x + object.rect.x * w,
        y: rect.y + object.rect.y * h,
        w: object.rect.w * w,
        h: object.rect.h * h,
      };

      const halfSide = Math.max(scaledRect.w, scaledRect.h) * 0.5;
      const center = [scaledRect.x + scaledRect.w * 0.5, scaledRect.y + scaledRect.h * 0.5];

      const attribs = { fill: object.fill, stroke: object.stroke, weight: 1 };
      const shape =
        object.shape === "rect"
          ? ["rect", attribs, [scaledRect.x, scaledRect.y], scaledRect.w, scaledRect.h]
          : ["circle", attribs, center, halfSide];

      return shape;
    }, room.objects),
  ];
};
